<template>
  <div class="middle-align">
    <TextField
      class="m1"
      :id="'bookingFrom'"
      :placeholder="$t('embed_code_request_msg')"
      :value="scriptValue"
    ></TextField>
  </div>
</template>

<script>
export default {
  props: ["clientName", "serverName"],
  computed: {
    scriptValue() {
      return (
        "<script src='https://" +
        this.serverName +
        "/request/" +
        this.clientName +
        "/?artist_id=&lang=en&version=2' type='text/javascript' charset='UTF-8'></" +
        "script>"
      );
    },
  },
  data: function () {
    return {
      bookingForm: "booking",
    };
  },
};
</script>

<style scoped>
.middle-align {
  padding: 1em;
}
</style>
